var exports = {
  "F": "parentIssuesList__pvGrJu",
  "D": "parentIssueItem__p1smwV",
};

module.exports = exports;
